"use strict";

var HtmlParser = '__RMD_HTML_PARSER__';
exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);


//////////////////
// WEBPACK FOOTER
// ./~/react-markdown/lib/symbols.js
// module id = 2477
// module chunks = 0